// Initialize Select2 on page load and Turbo navigation
document.addEventListener('turbo:load', initializeSelect2);
document.addEventListener('DOMContentLoaded', initializeSelect2);

function initializeSelect2() {
  // Initialize all select2-multiple elements
  const multipleSelects = document.querySelectorAll('.select2-multiple');

  multipleSelects.forEach(function(element) {
    const $element = $(element);

    // Destroy existing Select2 instance if it exists
    if ($element.hasClass('select2-hidden-accessible')) {
      $element.select2('destroy');
    }

    // Initialize Select2
    $element.select2({
      theme: 'bootstrap-5',
      width: '100%',
      placeholder: $element.data('placeholder') || 'Select options...',
      allowClear: true,
      closeOnSelect: false,
      tags: false
    });

    // Re-dispatch a native bubbling change event so Stimulus data-action listeners
    // (which use addEventListener) reliably fire when Select2 updates the value.
    // Select2 triggers its own jQuery-namespaced events but doesn't guarantee a
    // native change event that bubbles, which breaks Stimulus's event delegation.
    $element.on('select2:select select2:unselect select2:clear', function() {
      element.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

// Also initialize on Turbo frame loads
document.addEventListener('turbo:frame-load', initializeSelect2);
